
import React from "react";
import PendingPodImageReport from "../PendingPodImageReport";

export default function PendingPodImageReportPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("pending-pod-image-report")) {
    return;
  }
  return (
    <div className="page-bilty">
      <PendingPodImageReport sessionObject={sessionObject} />
    </div>
  );
}